// extracted by mini-css-extract-plugin
export default {"wrap":"AddEditItem_wrap__VYAPq","backlink":"AddEditItem_backlink__lMLoz"};